// ไฟล์สำหรับ Security Utilities และการตรวจสอบความปลอดภัย

import { clearPermissionCache } from '../services/PermissionGroup';

/**
 * ตรวจสอบว่า sessionStorage ถูกแก้ไขหรือไม่
 * เพื่อป้องกันการปลอมแปลงข้อมูล
 */
export function detectSessionStorageTampering() {
  // ตรวจสอบการเปลี่ยนแปลง sessionStorage โดยไม่ได้รับอนุญาต
  const originalSetItem = sessionStorage.setItem;
  const originalRemoveItem = sessionStorage.removeItem;
  const originalClear = sessionStorage.clear;

  // Override sessionStorage methods เพื่อตรวจจับการแก้ไข
  sessionStorage.setItem = function(key, value) {
    if (key === 'usergroup' || key === 'userEmail' || key === 'GraphAccessToken' || key === 'userProfile') {
      // ล้าง profile cache เมื่อมีการ tamper เนื่องจากอาจเป็นการพยายามปลอมเป็นคนอื่น
      if (key === 'userEmail' || key === 'userProfile') {
        sessionStorage.removeItem('userProfile');
      }
      
      // ล้าง permission cache เมื่อมีการแก้ไขข้อมูลสำคัญ
      clearPermissionCache();
      
      // บันทึกการพยายามแก้ไข (ส่งไปยังระบบ monitoring ได้)
      logSecurityEvent('sessionStorage_modification_attempt', { key, value });
    }
    
    return originalSetItem.call(this, key, value);
  };

  sessionStorage.removeItem = function(key) {
    if (key === 'usergroup' || key === 'userEmail' || key === 'GraphAccessToken') {
      // ล้าง profile cache เมื่อมีการ tamper
      if (key === 'userEmail' || key === 'userProfile') {
        sessionStorage.removeItem('userProfile');
      }
      
      clearPermissionCache();
      logSecurityEvent('sessionStorage_removal_attempt', { key });
    }
    
    return originalRemoveItem.call(this, key);
  };

  sessionStorage.clear = function() {
    clearPermissionCache();
    // ล้าง profile cache เมื่อมีการ clear sessionStorage
    sessionStorage.removeItem('userProfile');
    logSecurityEvent('sessionStorage_clear_attempt', {});
    
    return originalClear.call(this);
  };
}

/**
 * บันทึกเหตุการณ์ความปลอดภัย
 */
function logSecurityEvent(eventType, data) {
  const event = {
    timestamp: new Date().toISOString(),
    type: eventType,
    data: data,
    userAgent: navigator.userAgent,
    url: window.location.href
  };
  
  //console.log('🔐 Security Event:', event);
  
  // ส่งไปยังระบบ monitoring (ถ้ามี)
  // sendToSecurityMonitoring(event);
}

/**
 * ตรวจสอบว่า URL ปลอดภัยสำหรับ redirect หรือไม่
 */
export function isUrlSafe(url) {
  if (!url) return false;
  
  try {
    const urlObj = new URL(url, window.location.origin);
    
    // อนุญาตเฉพาะ internal URLs เท่านั้น
    if (urlObj.origin !== window.location.origin) {
      return false;
    }
    
    // Whitelist ของ paths ที่อนุญาต
    const allowedPaths = [
      '/auth/',
      '/backoffice/',
      '/service',
      '/uniform-survey',
      '/404',
      '/'
    ];
    
    const isAllowed = allowedPaths.some(path => urlObj.pathname.startsWith(path));
    
    if (!isAllowed) {
      return false;
    }
    
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * ฟังก์ชัน navigate ที่ปลอดภัย
 */
export function safeNavigate(navigate, url, options = {}) {
  if (!isUrlSafe(url)) {
    // redirect ไปหน้า home แทน
    navigate('/', options);
    return false;
  }
  
  navigate(url, options);
  return true;
}

/**
 * เริ่มต้นระบบตรวจสอบความปลอดภัย
 */
export function initializeSecurity() {
  detectSessionStorageTampering();
  
  // ตรวจสอบ console tampering
  let devtools = {
    open: false,
    orientation: null
  };
  
  const threshold = 160;
  
  setInterval(() => {
    if (window.outerHeight - window.innerHeight > threshold || 
        window.outerWidth - window.innerWidth > threshold) {
      if (!devtools.open) {
        devtools.open = true;
        logSecurityEvent('devtools_opened', {});
      }
    } else {
      devtools.open = false;
    }
  }, 500);
}
